import { createModel } from '@rematch/core';
import { selectors } from './selector';
import { RootState } from '../../store';
import { ImagingFacility } from '../../models/imaging-facility';
import { storeByIMPSId } from '../../utils/converter';
import { getImagingFacilities } from '../../apis/emr-data';

export interface State {
    allIds: number[];
    byId: Dictionary<ImagingFacility>;
    loading: Dictionary<boolean>;
}

export const imagingFacilities = createModel<State>({
    state: {
        allIds: [],
        byId: {},
        loading: {}
    },
    reducers: {
        update: (
            state: State,
            data: ImagingFacility[],
            loadingKey?: string
        ): State => {
            const byId = {
                ...state.byId,
                ...storeByIMPSId(data)
            };
            return {
                ...state,
                allIds: Object.keys(byId).map(x => +x),
                byId: byId,
                ...loadingKey && {
                    loading: {
                        ...state.loading,
                        [loadingKey]: false
                    }
                }
            };
        },
        loading: (
            state: State,
            loadingKey: string,
            loading: boolean
        ): State => ({
            ...state,
            loading: {
                ...state.loading,
                [loadingKey]: loading
            }
        })
    },
    effects: () => ({
        async getImagingFacilitiesAsync(
            _: Undefinable<{}>,
            rootState: RootState
        ) {
            if (selectors.getImagingFacilityIds(rootState.imagingFacilities).length === 0) {
                try {
                    const data = await getImagingFacilities();
                    this.update(data);
                } catch (e) {
                    window.console.log(e);
                }
            }
        }
    })
});
